import tw, { styled } from 'twin.macro';
import IFrame from 'react-onload-iframe';

export const StyledContainer = styled.div`
  ${tw`container-stack-context`}
`;

export const StyledIframe = styled(IFrame, {
  shouldForwardProp: (prop) => !['height', 'hideOnMobile'].includes(prop),
})<{
  height?: Queries.kontent_item_iframe_elements_height_enum | null;
  hideOnMobile?: boolean;
}>`
  ${tw`w-full`}

  ${({ hideOnMobile }) => hideOnMobile && tw`hidden lg:block`}
  ${({ height }) => {
    switch (height) {
      case 'vh_50':
        return tw`h-[50vh]`;
      case 'vh_80':
        return tw`h-[80vh]`;

      case 'vh_100':
      default:
        return tw`h-screen`;
    }
  }}
`;

export const StyledSection = styled.section<{ hasBackground: boolean; isFullWidth: boolean }>`
  ${tw`w-full h-full`}
  ${tw`py-8`}
  
  ${({ hasBackground }) => hasBackground && tw`bg-ui-colours-ui1`}
  ${({ isFullWidth }) => !isFullWidth && tw`px-2`}

  ${StyledContainer} {
    ${({ isFullWidth }) => !isFullWidth && tw`rounded-lg`}
  }

  ${StyledIframe} {
    ${({ isFullWidth }) => (isFullWidth ? tw`w-full` : [tw`container`, tw`rounded-lg`])}
  }
`;
